export enum ConsentType {
  USER_RESEARCH = 'user_research',
  AMPLITUDE = 'amplitude',
}
